// @ts-check
import { instantiate } from './instantiate.js';
import { defaultBrowserSetup } from './platforms/browser.js';

/** @type {import('./index.d').init} */
export async function init(_options) {
    /** @type {import('./index.d').Options} */
    const options = _options || {
        /** @returns {import('./instantiate.d').Imports} */
        get imports() { (() => { throw new Error("No imports provided") })() }
    };
    let module = options.module;
    if (!module) {
        module = fetch(new URL("ExportedSDF.wasm", import.meta.url))
    }
    const instantiateOptions = await defaultBrowserSetup({
        module,
        imports: options.imports,
    })
    return await instantiate(instantiateOptions);
}
